import { render, staticRenderFns } from "./PorModelosSituacao.vue?vue&type=template&id=c210beda&scoped=true&lang=pug&"
import script from "./PorModelosSituacao.vue?vue&type=script&lang=js&"
export * from "./PorModelosSituacao.vue?vue&type=script&lang=js&"
import style0 from "./PorModelosSituacao.vue?vue&type=style&index=0&id=c210beda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c210beda",
  null
  
)

export default component.exports